import apiClient from './ApiClient'
//console.log(apiClient)

export default {
  dajCenovnik() {
    return apiClient.get('/cenovnik')
  },
  sacuvajKorpu(korpa, ukupnoZaUplatu, uplatilac, email) {
    return apiClient.post('/sacuvajKorpu', {
      korpa,
      ukupnoZaUplatu,
      uplatilac,
      email
    })
  },
  prepareCheckout(ukupnoZaUplatu, narudzbinaId) {
    //let formData = new FormData()
    //formData.append('ukupnoZaUplatu', { ukupnoZaUplatu})
    return apiClient.post('/prepareCheckout', { ukupnoZaUplatu, narudzbinaId })
  },
  sacuvajCheckoutId(narudzbinaId, checkoutId) {
    return apiClient.post('/sacuvajCheckoutId', { narudzbinaId, checkoutId })
  },
  // getPaymentStatus(checkoutId) {
  //   return apiClient.get('/getPaymentStatus?checkoutId=' + checkoutId)
  // },
  savePaymentStatus(checkoutId) {
    return apiClient.post('/savePaymentStatus', { checkoutId })
  },
  dajStatusNarudzbine(checkoutId) {
    return apiClient.get('/dajStatusNarudzbine?checkoutId=' + checkoutId)
  }
  // sendPaymentStatusMail(email, data) {
  //   debugger
  //   let formData = new FormData()
  //   formData.append('email', email)
  //   formData.append('status', data.status)
  //   formData.append(
  //     'broj_porudzbine',
  //     data.broj_porudzbine ? data.broj_porudzbine : ''
  //   )
  //   formData.append('iznos', data.iznos)
  //   formData.append('valuta', data.valuta)
  //   formData.append('tip_kartice', data.tip_kartice)
  //   formData.append('vrene_transakcije', data.vrene_transakcije)
  //   formData.append('auth_kod_banke', data.auth_kod_banke)
  //   return apiClient.post('/sendPaymentStatusMail', formData)
  // }
}
